<template>
  <vendor-list :memberFlag="1" />
</template>
<script>
import VendorList from './busi/vendor-list.vue'
export default {
  name: 'MemberVendors',
  components: { VendorList },
  data() {
    return { query: { memberFlag: 1 }}
  }
}
</script>
